import React from "react";

const Pokeinfo = ({ data }) => {
  console.log(data);
  return (
    <>
      {
       (!data)?"":(
        <>
           <h1>{data.name} </h1>
            <img src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${data.id}.svg`} alt="" />   
          <div className="Habilidades">
            {
               data.abilities.map(poke=>{
                 return(
                   <> 
                    <div className="Grupo">
                     <h2>{poke.ability.name}</h2>
                    </div>
                   </>
                 )
               })
            }
          </div>
          <div className="estado-base">
            {
              data.stats.map(poke=>{
                return(
                  <> 
                     <h3>{poke.stat.name}:{poke.base_stat}</h3>
                  </>
                )
              })
            }
          </div>
        </>
       ) 
      }
    </>
  );
};

export default Pokeinfo;